import React from 'react';

export default class SubscriptionInfoCard extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		// console.log("PricingCard", this.props)
		return (
			<div className="SubscriptionInfoCard">
				<div className="w-full pb-4 mt-6">
					<h3 className="text-sm md:text-lg">
						Monthly Subscription <span className="float-right">$25.00</span>
					</h3>
					<ul className="list-disc ml-4 md:ml-6 mt-2 mb-5 font-extralight text-sm md:text-base">
						<li>Setup & maintain your property's lodging tax requirements</li>
						<li>
							Prepare, file and remit your lodging tax returns correctly and
							on-time
						</li>
						<li>Manage any tax agency correspondence and notices</li>
					</ul>
					<h3 className="text-sm md:text-lg">
						One-time License Setup Fee
						<span className="float-right">$75.00</span>
					</h3>
					<ul className="list-disc ml-4 md:ml-6 mt-2 mb-5 font-extralight text-sm md:text-base">
						<li>Review and update any existing tax licenses</li>
						<li>Apply for any additional required tax licenses</li>
						<li>Note: Additional license fees may be required</li>
					</ul>
				</div>
			</div>
		);
	}
}
